module.exports = __webpack_public_path__ + "img/Logo-Aarak.480b9e69.svg";